import React from 'react'

export default function PageNotFound() {
  return (
    <div><p>Buy Course To Get Access</p> 
    <p>If Already Bought Than Refresh</p>    </div>
  )
}
